import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import { registerTenant, verifyEmail } from "../../../actions/tenantActions";
import {
  Box,
  Flex,
  Image,
  Heading,
  Icon,
  IconButton,
  Text,
  useToast,
  VStack,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import {
  white,
  newBorder,
  textPrimary,
  textSecondary,
  primaryAlt,
  buttonRed,
  buttonRedText,
  dark,
} from "../../../utils/colors";
import { FaArrowLeft } from "react-icons/fa6";

import { motion } from "framer-motion";

import { logout } from "../../../actions/authActions";
import { useTranslation } from "react-i18next";
import testupscale from "../../../assets/images/testupscale.png";
// import dentacasa from "../../../assets/icons/dentacasa.svg";
import FormControlDefault from "../../../components/input/FormControlDefault";
import FormControlPassword from "../../../components/input/FormControlPassword";
// import LanguageButtonMain from "../../../components/buttons/LanguageButtonMain";
import { resetPasswordConfirmAction } from "../../../actions/authActions";

const ResetPasswordPage = () => {
  // GENERAL
  const { slug } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toast = useToast();

  // CONSTANTS
  const [show, setShow] = React.useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  // const [clinicName, setClinicName] = useState(""); // Add clinicName state
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [repeatPassword, setRepeatPassword] = useState("");
  // const [verificationCode, setVerificationCode] = useState("");
  // const [loadingMessage, setLoadingMessage] = useState("");

  const storedLanguage = localStorage.getItem("language");
  const initialLanguage = storedLanguage || "en"; // Default to 'en'
  const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

  const email = searchParams.get("email");
  const token = searchParams.get("token");

  // const [clinicName, setClinicName] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  // const [accepted, setAccepted] = useState(false);

  const [errors, setErrors] = useState({});

  // State for managing video load
  const [videoLoaded, setVideoLoaded] = useState(false);

  // REDUX
  // const publicInviteInfo = useSelector((state) => state.publicInviteInfo);
  // const { loading, error, success, info } = publicInviteInfo;

  // STEPS
  const [currentStep, setCurrentStep] = useState(0);

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const authUpdatePassword = useSelector((state) => state.authUpdatePassword);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = authUpdatePassword;

  // VALIDATION
  // const isNameError = name === "";
  const doPasswordsMatch = password === repeatPassword;

  // Password validation: At least 6 characters and 1 number
  const passwordRegex = /^(?=.*\d).{6,}$/;
  const isPasswordEmpty = password === "";
  const isPasswordInvalid = !passwordRegex.test(password) && !isPasswordEmpty;

  // TOOLTIP VALIDATION MESSAGES
  const tooltipMessages = [];

  // if (isNameError) tooltipMessages.push(t("formError.firstNameRequired"));

  // // Password error messages
  if (isPasswordEmpty) {
    tooltipMessages.push(t("formError.passwordRequired"));
  } else if (isPasswordInvalid) {
    tooltipMessages.push(t("formError.passwordInvalid"));
  }

  if (!doPasswordsMatch && repeatPassword) {
    tooltipMessages.push(t("formError.passwordMismatch"));
  }

  // USE EFFECT

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 100);
  }, [navigate]);

  useEffect(() => {
    if (errorUpdate) {
      console.error("Error:", errorUpdate);
      if (errorUpdate === "Invalid or expired token.") {
        toast({
          title: t("toasts.changePasswordErrorToken"),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: t("toasts.changePasswordError"),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  }, [errorUpdate, toast, t]);

  useEffect(() => {
    if (userInfo) {
      dispatch(logout());
    }
  }, [userInfo, dispatch]);

  // useEffect(() => {
  //   dispatch(getPublicInviteInfoAction(slug, email));
  // }, [dispatch, slug, email]);

  // HANDLERS

  // STEPS HANDLERS

  // SUBMIT
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     await dispatch(resetPasswordConfirmAction(email, token, password));

  //     // After successful invite acceptance, log the user in
  //     await dispatch(login(email, password, currentLanguage));

  //     // ✅ Optional: redirect to dashboard or tenant selector
  //     navigate("/dashboard"); // or any other post-login route
  //   } catch (err) {
  //     console.error("Invite or login failed", err.message);
  //     // Optionally show toast or error state
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(
        resetPasswordConfirmAction(email, token, password, currentLanguage)
      );
      // ✅ Show toast on success
      toast({
        title: t("toasts.resetPasswordSuccess"),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      const message = err?.response?.data?.message || "Unknown error";
      console.error("Reset password error:", message);
    }
  };

  // LOG
  // console.log("info", info);
  // console.log("data", data);

  return (
    <>
      <Helmet>
        <title>{t("pageTitle.resetPasswordPage")}</title>
        <meta
          name="description"
          content={t("pageDescription.resetPasswordPage")}
        />
      </Helmet>

      {/* <Box position="fixed" top="2.5rem" right="2.5rem" zIndex="9">
        <LanguageButtonMain />
      </Box> */}

      {show && (
        <Flex
          w="100%"
          h="100%"
          minH="100vh"
          align="stretch"
          position="relative"
          justify="flex-start"
          bg={white}
          as={motion.div}
          exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
          initial={{ opacity: 0, x: 0, y: 0 }}
          animate={{
            opacity: 1,
            x: 0,
            y: 0,
            transition: { duration: 0.15 },
            // transition: { delay: 0.3, duration: 0.2 },
          }}
        >
          {/* <Box position="fixed" top="2.5rem" left="2.5rem" zIndex={1000}>
            <Link to="/">
              <Image src={dentacasa} h="1.5rem" w="initial" />
            </Link>
          </Box> */}
          <Box w="29%" position="relative" flexShrink={0}>
            <Flex w="100%" h="100%" position="relative">
              <Image src={testupscale} w="100%" h="100%" objectFit="cover" />
              <Flex
                position="fixed"
                zIndex="1"
                top="0"
                left="0"
                w="29%"
                h="100%"
                as={motion.div}
                initial={{ opacity: 0, y: 0 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  transition: { delay: 0, duration: 1 },
                }}
              >
                <Video
                  playsInline
                  autoPlay
                  loop
                  muted
                  onLoadedData={() => setVideoLoaded(true)}
                  onError={() => setVideoLoaded(false)}
                  style={{ display: videoLoaded ? "block" : "none" }}
                  src="https://bucket.mailersendapp.com/0p7kx4xmrvl9yjre/z3m5jgr1omx4dpyo/files/9ca7a800-8d36-414c-a9f1-d5ac05d4a695/videonew2.mp4"
                ></Video>
              </Flex>
            </Flex>
          </Box>

          {!successUpdate ? (
            <Flex
              w="100%"
              align="flex-start"
              justify="center"
              pl="100px"
              pt="2rem"
              direction="column"
            >
              {currentStep === 1 && (
                <Box
                  position="absolute"
                  top="2rem"
                  left={`calc(29% + 2rem)`}
                  zIndex={1000}
                >
                  <IconButton
                    border={`1px solid ${newBorder}`}
                    size="md"
                    borderRadius="100rem"
                    bg={white}
                    fontSize="20px"
                    icon={<Icon h="0.875rem" as={FaArrowLeft} />}
                    onClick={() => setCurrentStep(0)}
                  />
                </Box>
              )}

              <form
                onSubmit={handleSubmit}
                style={{
                  width: "100%",
                  maxWidth: "420px",
                }}
              >
                <Heading
                  fontSize="1.875rem"
                  fontWeight="700"
                  color={textPrimary}
                  // mb={6}
                >
                  {/* <Text
                    as="span"
                    mr={1.5}
                    color={primaryAlt}
                    textTransform="capitalize"
                  >
                    {info && info.clinicName}
                  </Text> */}
                  {t("register.resetPasswordTitle")}{" "}
                </Heading>

                <Text
                  color={textSecondary}
                  fontWeight="500"
                  size="sm"
                  m="0.5rem 0 1rem"
                >
                  {t("register.resetPasswordText")}{" "}
                </Text>

                <VStack spacing={0} align="stretch" m="2rem 0 0">
                  <FormControlDefault
                    labelFontSize="0.8rem"
                    size="lg"
                    label={t("form.email")}
                    value={email}
                    isReadOnly
                    isRequired
                    error={errors.email}
                    errorMessage={errors.email}
                    onChange={() => {}}
                    isDisabled
                    isLabelEnabled
                  />

                  <FormControlPassword
                    labelFontSize="0.8rem"
                    size="lg"
                    label={t("form.password")}
                    value={password}
                    isRequired
                    placeholder={t("placeholder.password")}
                    error={errors.password}
                    errorMessage={errors.password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrors((prev) => ({
                        ...prev,
                        password: e.target.value ? "" : "Password is required",
                      }));
                    }}
                    isLabelEnabled
                  />

                  <FormControlPassword
                    labelFontSize="0.8rem"
                    size="lg"
                    label={t("form.repeatPassword")}
                    value={repeatPassword}
                    isRequired
                    placeholder={t("placeholder.repeatPassword")}
                    error={
                      errors.repeatPassword ||
                      (!doPasswordsMatch && repeatPassword)
                    }
                    errorMessage={
                      !doPasswordsMatch && repeatPassword
                        ? t("formError.passwordMismatch")
                        : errors.repeatPassword
                    }
                    onChange={(e) => {
                      setRepeatPassword(e.target.value);
                      setErrors((prev) => ({
                        ...prev,
                        repeatPassword: e.target.value
                          ? ""
                          : t("formError.repeatRequired"),
                      }));
                    }}
                    isLabelEnabled
                  />
                </VStack>

                <Flex w="100%" m="0rem 0 " direction="column">
                  {/* <Box p="0.5rem 0">
                    <Agreement noQuestion />
                  </Box> */}

                  <Tooltip
                    bg={buttonRed}
                    color={buttonRedText}
                    padding="0.5rem 1rem"
                    borderRadius="1rem"
                    placement="top"
                    label={
                      tooltipMessages.length > 0 ? (
                        <Flex
                          direction="column"
                          justify="center"
                          align="center"
                        >
                          {tooltipMessages.map((message, index) => (
                            <Text
                              key={index}
                              color={buttonRedText}
                              fontSize="xs"
                              fontWeight="500"
                              textAlign="center"
                            >
                              {message}
                            </Text>
                          ))}
                        </Flex>
                      ) : null
                    }
                    isDisabled={tooltipMessages.length === 0} // Disable tooltip if no errors
                  >
                    <Button
                      type="submit"
                      m="1rem 0 0"
                      h="3rem"
                      borderRadius="10rem"
                      bg={textPrimary}
                      color={white}
                      border={`1px solid ${textPrimary}`}
                      textAlign="center"
                      w="100%"
                      _hover={{
                        // bg: "rgba(13, 12, 34, 0.8)",
                        bg: primaryAlt,
                        color: white,
                        // border: `rgba(13, 12, 34, 0.8)`,
                        border: primaryAlt,
                      }}
                      isDisabled={tooltipMessages.length > 0} // Disable if any errors exist
                      isLoading={loadingUpdate}
                    >
                      {t("register.renewPasswordButtonLabel")}
                    </Button>
                  </Tooltip>

                  <Text
                    color={textSecondary}
                    fontWeight="500"
                    fontSize="xs"
                    textAlign="center"
                    m="1rem 0 1rem"
                  >
                    {t("register.resetPasswordExpirationText")}{" "}
                  </Text>
                </Flex>
              </form>
              {/* ) : (
                <Flex
                  w="100%"
                  align="center"
                  justify="center"
                  // pl="100px"
                  direction="column"
                  maxW="600px"
                >
                  <Image h="4rem" w="auto" m="0rem 0 0" src={noServices} />
                  <Text
                    color={textPrimary}
                    fontSize="1.875rem"
                    fontWeight="700"
                    m="1.5rem 0 0.5rem"
                    textAlign="center"
                  >
                    {t("user.noInviteTitle")}
                  </Text>
                  <Text
                    color={textSecondary}
                    fontSize="md"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {t("user.noInviteText")}
                  </Text>
                </Flex>
              )} */}
            </Flex>
          ) : (
            <>
              <Flex
                w="100%"
                align="flex-start"
                justify="center"
                pl="100px"
                pt="2rem"
                direction="column"
              >
                <Flex w="100%" maxW="420px" direction="column">
                  <Box>
                    <Heading
                      fontSize="1.875rem"
                      fontWeight="700"
                      color={textPrimary}
                      //   mb={6}
                      m="0 0 0.5rem"
                    >
                      {t("register.updatePasswordSuccess")}
                    </Heading>
                    <Text
                      fontSize="1rem"
                      fontWeight="500"
                      color={textSecondary}
                      //   mb={6}
                      lineHeight="1.5rem"
                      textAlign="left"
                    >
                      {email && (
                        <Text as="span" color={primaryAlt} mr={1.5}>
                          {email}
                        </Text>
                      )}
                      {t("register.updatePasswordSuccessText")}
                    </Text>

                    <Button
                      onClick={() => {
                        navigate("/login");
                      }}
                      m="2.5rem 0 0"
                      mb={4}
                      h="3.5rem"
                      borderRadius="10rem"
                      bg={dark}
                      color={white}
                      // border={`1px solid ${dark}`}
                      textAlign="center"
                      w="100%"
                      _hover={{
                        bg: primaryAlt,
                        color: white,
                        border: `1px solid ${primaryAlt}`,
                      }}
                    >
                      {t("common.login")}
                    </Button>
                  </Box>
                </Flex>
              </Flex>
            </>
          )}
        </Flex>
      )}
    </>
  );
};

const Video = styled.video`
  display: block;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
`;

export default ResetPasswordPage;
